import { FC, useState } from 'react'
import { UploadAvatar } from 'shared/containers/UploadAvatar'
import { Avatar } from 'shared/components/Avatar'

interface UpdateAvatarProps {
    isEditable: boolean
    updatePhoto: (file: File) => void
    photo: string | null
    name: string
    isCompany: boolean
}

export const UpdateAvatarForm: FC<UpdateAvatarProps> = ({
    isEditable,
    updatePhoto,
    photo,
    name,
    isCompany,
}) => {
    const [currentPhoto, setCurrentPhoto] = useState<string | null>(
        photo ?? null,
    )

    const onPhotoChange = (file: File) => {
        setCurrentPhoto(URL.createObjectURL(file))
        updatePhoto(file)
    }

    if (isEditable) {
        return (
            <UploadAvatar
                initialPhoto={currentPhoto}
                onPhotoChange={onPhotoChange}
            />
        )
    }

    return (
        <Avatar
            photo={photo}
            name={name}
            jobs={isCompany ? 'Юридическое лицо' : 'Физическое лицо'}
        />
    )
}
